import { Flex } from '@chakra-ui/layout';
import React from 'react';
import { Navigate, useParams } from 'react-router';

import { z } from 'zod/v4';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { DataPipelineDetails } from '~/packages/dataPipeline/ui/details/DataPipelineDetails';

// Types
const RouteParamsStruct = z.object({
  meshId: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  const params = useParams();
  const { meshId } = RouteParamsStruct.parse(params);

  return (
    <DataPipelineDetails
      organizationId={user.organization.id}
      meshId={meshId}
    />
  );
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/" />;
    }}
  >
    <Flex direction="column" padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}>
      <RouteBase />
    </Flex>
  </RouteErrorBoundary>
);
